import React, { useState, useEffect } from "react";
import styles from "./DashboardHome.module.css";

import applicationIcon from "../../assets/images/ApplicationIcon.svg";
import checkIcon from "../../assets/images/CheckIcon.svg";
import shape1 from "../../assets/images/shape1.svg";
import shape2 from "../../assets/images/shape2.svg";
import shape3 from "../../assets/images/shape3.svg";
import round from "../../assets/images/round.svg";
import listIcon from "../../assets/images/listIcon.svg";
import uploadIcon from "../../assets/images/uploadIcon.svg";
import chatIcon from "../../assets/images/chatIcon.svg";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import greater from "../../assets/images/greater.svg";
import greater2 from "../../assets/images/greater2.svg";

import moment from "moment";

import { Link } from "react-router-dom";

import { allApplicationsApi } from "../../config/allApplicationsApi";
import { visaPackageApi } from "../../config/visaPackageApi";

export default function DashboardHome(props) {
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState([]);
  const [onGoing, setOnGoing] = useState(0);
  const [completed, setCompleted] = useState(0);

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const allApplications = async (token) => {
        const allapplications = await allApplicationsApi(token);

        if (allapplications.data) {
          const Applications = await allapplications.data.data;

          Applications.reverse();

          setApplications([]);
          setOnGoing(0);
          setCompleted(0);
          Applications.map((value) => {
            setApplications((applications) => [...applications, value]);
            if (value.status === "SUCCESSFUL" || value.status === "REJECTED") {
              setCompleted((completed) => completed + 1);
            } else {
              setOnGoing((onGoing) => onGoing + 1);
            }
          });
          setLoading(false);
        } else if (allapplications.error) {
          console.log(allapplications.error);
          setLoading(false);
        }
      };
      allApplications(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  return (
    <div className={styles.main}>
      <div className={styles.firstSectionCent}>
        <div className={styles.firstSection}>
          <div className={styles.firstSection1}>
            <div className={styles.firstSection1Boxes}>
              <div className={styles.box1}>
                <img
                  src={applicationIcon}
                  alt="Application List"
                  className={styles.icon1}
                />
                <div className={styles.innerbox1}>
                  {loading ? (
                    <>
                      <div
                        className="spinner-border"
                        role="status"
                        style={{
                          color: "#ffffff",
                          lineHeight: "20px",
                          fontSize: "20px",
                          marginTop: "20px",
                        }}
                      ></div>
                      <br />
                      <br />
                    </>
                  ) : (
                    <h4 className={styles.num}>{onGoing.toLocaleString()}</h4>
                  )}
                  <p className={styles.pera}>Ongoing Applications</p>
                </div>
                {/* <img src={shape1} alt="Shape1" className={styles.shape1} /> */}
              </div>
              <div className={styles.box2}>
                <img
                  src={checkIcon}
                  alt="Check List"
                  className={styles.icon2}
                />
                <div className={styles.innerbox1}>
                  {loading ? (
                    <>
                      <div
                        className="spinner-border"
                        role="status"
                        style={{
                          color: "#ffffff",
                          lineHeight: "20px",
                          fontSize: "20px",
                          marginTop: "20px",
                        }}
                      ></div>
                      <br />
                      <br />
                    </>
                  ) : (
                    <h4 className={styles.num}>{completed.toLocaleString()}</h4>
                  )}
                  <p className={styles.pera}>Completed Applications</p>
                </div>
                {/* <img src={shape2} alt="Shape2" className={styles.shape2} /> */}
              </div>
            </div>
            <div className={styles.firstSection1Full}>
              <div>
                <img src={chatIcon} alt="Chat Avatar" />
              </div>
              <div className={styles.boxx}>
                <h1 className={styles.fullSectionHead}>
                  Need help? Connect with our Virtual Assistant
                </h1>
                <p className={styles.fullSectionPera}>
                  If you need answers or help with your visa application, we are
                  one click away.
                  <br /> Chat with our virtual assistant for any support
                  regarding your application.
                </p>
                <p className={styles.fullSectionLink}>Chat Now</p>
              </div>
              {/* <img src={shape2} alt="Shape3" className={styles.shape3} /> */}
            </div>
          </div>
          <div className={styles.firstSection2}>
            <h1 className={styles.sec2Heading}>Status</h1>
            <p className={styles.sec2pera}>Canada Application</p>
            <div className={styles.tenperCont}>
              <p className={styles.sec2pera2}>10 % Completed</p>
              <img src={round} alt="round" />
            </div>
            <div className={styles.firstSection1Box}>
              <div className={styles.boxxx}>
                <div className={styles.listBox}>
                  <img src={listIcon} alt="List Icon" />
                </div>
                <h1 className={styles.boxHead}>View Application</h1>
              </div>
              <div className={styles.boxxx}>
                <div className={styles.uploadBox}>
                  <img src={uploadIcon} alt="Upload Icon" />
                </div>
                <h1 className={styles.boxHead}>Upload</h1>
              </div>
            </div>
          </div>
          <div className={styles.firstSectionMobileOnly}>
            <h1 className={styles.mobileHead}>Need Help?</h1>
            <p className={styles.mobilePera}>
              Connect with our Virtual Assistant
            </p>
            {/* <img src={shape2} alt="Shape3" className={styles.shape3} /> */}
          </div>
        </div>
      </div>
      {/* Second Section */}

      <div className={styles.secondSection}>
        <h1 className={styles.secondSectionHead}>Ongoing applications </h1>

        <div className={styles.secondInsideBox}>
          {loading ? (
            <div className={styles.loader}>
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : 
          applications.length === 0 ? (
            <div className={styles.lengthCont}>
              <h2 className={styles.contHead}>No Application Available</h2>
            </div>
          ) :
          (

            <TableContainer component={Paper} style={{ boxShadow: "none" }}>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <div className={styles.tableHead}>Destination</div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={styles.tableHead}>Date</div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={styles.tableHead}>Status</div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={styles.tableHead}>Action</div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {applications.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell className={styles.tableInHead} align="center">
                        <span className={styles.tableInHead1}>
                          {value.destination.name}
                        </span>
                        <p className={styles.type}>{value.visa_package.name}</p>
                      </TableCell>
                      <TableCell className={styles.tableInHead} align="center">
                        <span className={styles.tableInHead1}>
                          {moment(new Date(value.created_at)).format(
                            "DD/MM/YYYY"
                          )}
                        </span>
                      </TableCell>
                      <TableCell className={styles.tableInHead} align="center">
                        {value.status !== undefined ? (
                          <span className={styles.status}>
                            {value.status.replace(/_/g, " ").toLowerCase()}
                          </span>
                        ) : (
                          <span className={styles.status}>Not Available</span>
                        )}
                      </TableCell>
                      <TableCell className={styles.tableInHead} align="center">
                      <Link to={`/dashboard/my-applications/application-center/${value._id}`}>
                        <span className={styles.action}>
                          <span style={{ width: "75%" }}>
                            {value.step.replace(/_/g, " ").toLowerCase()} &nbsp;{" "}
                          </span>
                            <img src={greater} alt="Greater" />
                        </span>
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
        <div className={styles.hide}>
          {loading ? (
            <div className={styles.loader}>
              <div className="spinner-border" role="status"></div>
            </div>
          ) : 
          applications.length === 0 ? (
            <div className={styles.lengthCont}>
              <h2 className={styles.contHead}>No Application Available</h2>
            </div>
          ) :
          (
            applications.map((value, index) => (
              <div className={styles.secondOnlyMobile} key={index}>
                <h4 className={styles.mobileSecondHead}>
                  {value.destination.name}{" "}
                  <p className={styles.mobileSecondType}>
                    {value.visa_package.name}
                  </p>
                </h4>
                <p className={styles.mobileSecondPera}>
                  {value.status !== undefined ? (
                    <span className={styles.status}>
                      {value.status.replace(/_/g, " ").toLowerCase()}
                    </span>
                  ) : (
                    <span className={styles.status}>Not Available</span>
                  )}
                </p>
                <Link to={`/dashboard/my-applications/application-center/${value._id}`}>
                <img src={greater2} alt="Greater " />
                </Link>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
